import { render, staticRenderFns } from "./PdfReport.vue?vue&type=template&id=b627573c&scoped=true&"
import script from "./PdfReport.vue?vue&type=script&lang=js&"
export * from "./PdfReport.vue?vue&type=script&lang=js&"
import style0 from "./PdfReport.vue?vue&type=style&index=0&id=b627573c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b627573c",
  null
  
)

export default component.exports